export enum sports_type_number {
    soccer = 1,
    baseball = 2,
    basket = 3,
    volleyball = 4,
    hockey = 5,
    tenis = 6,
    football = 7,
}

export const tabWhiteList = ["", "soccer", "baseball", "basket", "volley", "hockey", "football", "egame", "ETC"]
export const top_game_sports_list = [
    { type: 1, sports: "soccer", display_name: "축구" },
    { type: 2, sports: "baseball", display_name: "야구" },
    { type: 3, sports: "basket", display_name: "농구" },
    { type: 4, sports: "volleyball", display_name: "배구" },
    { type: 5, sports: "hockey", display_name: "하키" },
    { type: 6, sports: "tenis", display_name: "테니스" },
    { type: 7, sports: "football", display_name: "풋볼" },
]

export interface BetslipTypes {
    bet_point: number
    total_odds: number | string
    expected_point: number
}
export interface membersType {
    team_id: number
    team_name: string
    is_home: boolean
}
export interface ticketsTypes {
    match_id: number
    match_date: string
    members: membersType[]
    markets: marketType
    selections: selectionType
}
export interface marketType {
    market_id: number
    market_type_id: number
    name: string
    handicap: number | string
}
export interface selectionType {
    selection_id: number
    odds: number | string
    kind: string
    is_suspended: boolean
    is_visible: boolean
    outcome: string
    name: string
}

export interface betDetailTypes {
    betticket_id   : number // 1202,
    username       : string // "ricky",
    stake          : number // 4000,
    total_odds     : string // "50.92",
    expected_price : number // 203688,
    paid_price     : number // 0,
    status         : ticketStatusType // "pending",
    folder_count   : number // 3,
    created_dt     : string // "2025-06-19T19:53:05.468150+09:00",
    updated_dt     : string // "2025-06-19T19:53:05.468171+09:00",
    folders        : betFolderTypes[]
}
export interface betFolderTypes {
    actual_selection_id: number | null
    selection_id     : number
    odds             : string // "2.07",
    status           : ticketStatusType // "pending",
    sport_name       : string // "축구",
    competition_name : string // "엘사리가 B",
    match_datetime   : string // "2025-06-20T00:00:00+09:00",
    home_team        : string // "탈린나 JK 레기온",
    away_team        : string // "파이데 린나메스콘드 U21",
    market_type      : string // "핸디캡",
    market_type_id   : number // 5500,
    selections       : folderSelectionType[]
}
export interface folderSelectionType {
    selection_id : number
    odds         : number | string
    is_selected  : boolean
    name         : string
    kind         : string
}

export type ticketStatusType = "pending" 
                                | "return" 
                                | "lost" 
                                | "won" 
                                | "winreturn" 
                                | "lostreturn" 

export const ticketResult = {
    pending: "대기",
    return: "적특",
    lost: "낙첨",
    won: "당첨",
    winreturn: "부분당첨",
    lostreturn: "부분낙첨",
}